export default function timeseriesToVideoTransformer(data) {
    // find the latest test id in each series and build a request url for a WPT video
    let tests = "";
    data.forEach((series) => {
        const test = series.data[series.data.length - 1].test;
        if (typeof test === "undefined") {
            return false;
        }
        // 170321_G5_64d141e736fee89b9df75bc451db9782-l:Previous,
        // Todo: we used to pass the specific run through using "-r:" but we don't have this in the time series data
        tests += test + "-l:" + encodeURIComponent(series.name) + ",";
    });
    // example URL for WPT create video
    // https://wpt.speedcurve.com/video/create.php?bg=000000&text=ffffff&slow=0&tests=170321_G5_64d141e736fee89b9df75bc451db9782-l:Previous,170817_G7_aeac1941fdce8a9ad3bf81453d1e1ca9-l:Latest&end=full
    // Todo: the WPT host should be pulled from env vars
    //return "https://wpt.speedcurve.com/video/create.php?tests=" + tests.slice(0, -1) + "&bg=1d262a&text=a6a6a6&end=visual&f=json";
    return ("https://wpt.speedcurve.com/video/create.php?tests=" +
        tests.slice(0, -1) +
        "&bg=000000&text=a6a6a6&end=visual&f=json");
}
